import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import CoachingPlan from 'records/CoachingPlan';
import User from 'records/User';
import UserAvatar from 'components/pure/utils/UserAvatar';
import {Link} from 'react-router';
import buildUrl from 'components/dashboard/buildUrl';
import './AdminDashInactivePlanRow.styl';
import MiniAvatarList from 'components/dashboard/admin/MiniAvatarList';
import ReactDOM from 'react-dom';
import scrollIntoView from 'dom-scroll-into-view';
import {HISTORY_ACTIONS} from 'components/StatsPage2.utils';

export default class AdminDashInactivePlanRow extends React.PureComponent {
  render() {
    const {user, lastPlan, overdue, adminId, fromPath, selected} = this.props;

    const managerId = user.id;

    const link = buildUrl({adminId: adminId, managerId}) + '/your-coaching';
    const state = fromPath
      ? {
          pathname: fromPath,
          action: HISTORY_ACTIONS.PUSH,
        }
      : {};

    if (selected) {
      window.requestAnimationFrame(() => {
        const domNode = ReactDOM.findDOMNode(this);
        const rect = domNode.getBoundingClientRect();
        const shouldScroll = rect.top < 0 || rect.bottom > window.innerHeight;
        if (shouldScroll) {
          scrollIntoView(domNode, window, {
            alignWithTop: false,
            offsetBottom: 20,
          });
        }
      });
    }

    return (
      <tr className={classNames('admin-dash-inactive-plan-row', selected && 'selected')}>
        <td>
          <div className="coach-cell">
            <UserAvatar user={user} />
            <Link
              to={{
                pathname: link,
                state,
              }}>
              <span className="generic-link">{user.getFullName()}</span>
            </Link>
          </div>
        </td>
        <td className="last-plan-cell">
          {lastPlan ? (
            <Link
              to={{
                pathname: link,
                state,
              }}>
              <UserAvatar user={lastPlan.recipient.info} />
              <span>{lastPlan.completedAt.format('MM/DD/YYYY')}</span>
            </Link>
          ) : (
            <div>N/A</div>
          )}
        </td>
        <td className="overdue-cell">
          <MiniAvatarList
            overdue
            plans={overdue}
            adminId={adminId}
            managerId={managerId}
            fromPath={fromPath}
          />
        </td>
      </tr>
    );
  }
}

AdminDashInactivePlanRow.propTypes = {
  user: PropTypes.instanceOf(User),
  lastPlan: PropTypes.instanceOf(CoachingPlan),
};
